import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ABOUT_IMAGE } from "@/lib/data";

export default function About() {
    return (
        <section data-testid="about-section" className="section-pad bg-bone2">
            <div className="container-wide grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                {/* Image */}
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="lg:col-span-6 relative"
                >
                    <div className="aspect-[4/5] overflow-hidden">
                        <img
                            src={ABOUT_IMAGE}
                            alt="Justin Brazier on site, Central Coast home builder"
                            loading="lazy"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="absolute -bottom-6 -right-4 md:-bottom-8 md:-right-8 bg-clay text-bone px-6 py-5 md:px-8 md:py-6 max-w-[240px]">
                        <div className="text-3xl md:text-4xl font-display font-light leading-none">30+</div>
                        <div className="mt-2 text-xs tracking-[0.2em] uppercase">Years of Experience</div>
                    </div>
                </motion.div>

                {/* Text */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, delay: 0.15 }}
                    className="lg:col-span-6"
                >
                    <div className="overline mb-5">About us</div>
                    <h2 className="font-display text-3xl md:text-5xl font-light leading-tight tracking-tight mb-8">
                        A Builder You<br />
                        <span className="italic text-clay">Can Trust.</span>
                    </h2>

                    <div className="space-y-5 text-ink2 text-base md:text-lg leading-relaxed">
                        <p>
                            Brazier Building &amp; Design delivers custom homes, renovations, and extensions across the Central Coast with a strong focus on quality and detail.
                        </p>
                        <p>
                            Over 30 years of hands-on experience with direct builder involvement on every project. Justin Brazier and his team handle everything — from new builds, townhouse developments and knockdown rebuilds to renovations, extensions and granny flats.
                        </p>
                        <p>
                            We work around you where possible — including keeping you on-site during renovations to save you accommodation costs. Based at Forresters Beach, servicing the Central Coast and Newcastle.
                        </p>
                    </div>

                    <div className="mt-10">
                        <Link
                            to="/contact"
                            data-testid="about-cta-contact"
                            className="btn-primary"
                        >
                            Contact Us
                        </Link>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
